import { ActionResult } from '../enums';
import type { ActionHandler } from '../types';
import { showConfirmationToast } from '~/utils/confirmation-toast.ts';

type ShowConfirmationToastOptions = {
  message?: string;
};

/**
 * Shows a confirmation toast with the message from action options.
 */
export const showConfirmationToastHandler: ActionHandler<
  ShowConfirmationToastOptions
> = async (action) => {
  const message = action.options?.message;

  if (!message) {
    return ActionResult.Error;
  }

  showConfirmationToast({ message });
  return ActionResult.Success;
};
